import React from 'react';

// @atlaskit
import { Validator } from '@atlaskit/form';

const email = (
  <Validator
    key="email"
    func={(value) => {
      const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(value);
    }}
    invalid="Must be a valid email."
    valid="Great!"
  />
);

const integer = (
  <Validator
    key="integer"
    func={(value) => {
      const regex = /^[0-9.,()]+$/;
      return regex.test(value);
    }}
    invalid="Must be only integer."
    valid="Great!"
  />
);

const minimum = (min = 3) => (
  <Validator
    func={value => value.length >= min}
    invalid={`Must be at least ${min} characters.`}
    key="minimum"
    valid="Great!"
  />
);

const number = (
  <Validator
    key="number"
    func={(value) => {
      const regex = /^[0-9()]+$/;
      return regex.test(value);
    }}
    invalid="Must be only numbers."
    valid="Great!"
  />
);

const password = (
  <Validator
    key="password"
    func={value => value.length >= 3}
    invalid="Password must be 3 characters."
    valid="Great!"
  />
);

const required = (
  <Validator
    key="required"
    func={value => value}
    invalid="This field is required."
    valid="Great!"
  />
);

const space = (
  <Validator
    key="space"
    func={value => value.search(' ') === -1}
    invalid="No spaces in this field."
    valid="Great!"
  />
);

const string = (
  <Validator
    key="string"
    func={(value) => {
      const regex = /^[a-zA-ZâÂüÜşŞıİöÖçÇğĞ ()]+$/;
      return regex.test(value);
    }}
    invalid="Must be text only."
    valid="Great!"
  />
);

const username = (
  <Validator
    key="username"
    func={(value) => {
      const regex = /^[a-zA-Z0-9]+$/;
      return regex.test(value);
    }}
    invalid="Must be a valid username."
    valid="Great!"
  />
);

export default {
  email,
  integer,
  minimum,
  number,
  password,
  required,
  space,
  string,
  username,
};
